<template>
  <div>
    <v-divider />
    <v-list-tile @click="selectPointGroup(pointGroup)">
      <v-list-tile-content>
        <v-list-tile-title>
          {{ pointGroup.name }}
        </v-list-tile-title>
        {{ pointGroup.locationCount }} 地点
      </v-list-tile-content>
      <v-list-tile-action>
        <v-btn @click="removePointGroup(pointGroup.id)" icon>
          <v-icon color="red">delete_forever</v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SimulationContentDeliveryLocationGroupImportGroup',
  props: {
    pointGroup: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    ...mapActions('simulation', {
      removePointGroup: 'REMOVE_POINT_GROUP',
      selectPointGroup: 'SELECT_POINT_GROUP',
    }),
  },
}
</script>

<style scoped></style>
